import { Component } from 'react';
import { connect } from 'react-redux';

import { listCustomerCreditCards } from 'redux/customerCreditCards/actions';

import CreditCardDisplay from './CreditCardDisplay';

class ListModal extends Component {
  componentDidMount() {
    const { props } = this;
    props.listCustomerCreditCards();
  }

  handleEditCreditCard = (e) => {
    e.preventDefault();
    const { props } = this;
    const id = e.currentTarget.getAttribute('data-id');
    props.onEditCreditCard(id);
  };

  handleSelectCreditCard = (e) => {
    e.preventDefault();
    const { props } = this;
    const id = e.currentTarget.getAttribute('data-id');
    const creditCard = props.customerCreditCards.data[id];
    props.onSelectCreditCard(creditCard);
  };

  render() {
    const { settings, customerCreditCards } = this.props;
    if (!settings.data || !customerCreditCards.data) {
      return null;
    }
    const creditCardIdArray = Object.keys(customerCreditCards.data);
    const displayArray = arrayOf2(creditCardIdArray);
    return (
      <>
        {displayArray.map((innerArray) => (
          <div key={innerArray[0]} className="c7-account-row">
            {innerArray.map((creditCardId) => {
              const creditCard = customerCreditCards.data[creditCardId];
              return (
                <div key={creditCard.id}>
                  <CreditCardDisplay creditCard={creditCard} boldName />
                  <br />
                  {creditCard.isDefault && (
                    <>
                      <br />
                      <em>(Default)</em>
                    </>
                  )}
                  <br />
                  <a
                    onClick={this.handleEditCreditCard}
                    data-id={creditCard.id}
                  >
                    Edit
                  </a>
                  &nbsp;&nbsp;|&nbsp;&nbsp;
                  <a
                    onClick={this.handleSelectCreditCard}
                    data-id={creditCard.id}
                  >
                    Select
                  </a>
                </div>
              );
            })}
          </div>
        ))}
      </>
    );
  }
}

const arrayOf2 = (array) => {
  const arrayOutput = [];
  let innerArray = [];
  array.forEach((element, index) => {
    innerArray.push(element);
    if ((index + 1) % 2 === 0) {
      arrayOutput.push(innerArray);
      innerArray = [];
    }
  });
  if (innerArray.length > 0) {
    arrayOutput.push(innerArray);
  }
  return arrayOutput;
};

const mapStateToProps = (state) => ({
  customerCreditCards: state.customerCreditCard,
  settings: state.setting
});

export default connect(mapStateToProps, {
  listCustomerCreditCards
})(ListModal);
